module.exports = __webpack_public_path__ + "static/img/PC-5.999f8e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcga/PC-5.png
// module id = y4FN
// module chunks = 0